import { injectable } from 'tsyringe';
import { KelasApiRepository } from '../../app/repository/api/KelasApiRepository';
import { Kelas } from '../../entities/Kelas';

@injectable()
export class KelasPresenter {
  private repository: KelasApiRepository;

  constructor(repository: KelasApiRepository) {
    this.repository = repository;
  }

  public getAllKelas(jenjang: string): Promise<Kelas[]> {
    return this.repository.getAllKelas(jenjang);
  }
}
